import getCommandButtonsForSxSPreview from '../utils/getCommandButtonsForSxSPreview';
import { resetSxSViewStoreAction } from 'owa-group-files-hub-store';
import { getSxSViewStore } from 'owa-group-files-hub-store';
import { SxSLayerView } from 'owa-sxs';
import { DatapointStatus } from 'owa-analytics';
import { observer } from 'mobx-react';
import * as React from 'react';

@observer
export default class FilesHubSxSLayerView extends React.Component<{}, {}> {
    render() {
        const store = getSxSViewStore();
        return (
            <SxSLayerView
                commandBarButtons={getCommandButtonsForSxSPreview()}
                onError={this.onError}
                onClose={this.onClose}
                onLoad={this.onLoad}
                viewState={store.viewState}
                children={false}
            /> // children means if we want to show right pane
        );
    }

    private onClose = async () => {
        resetSxSViewStoreAction('closeSxS');
    };

    private onError = async (errorMessage: string, error?: Error) => {
        error = error || new Error(errorMessage);
        this.endDatapoint('onError', error);
    };

    private onLoad = async () => {
        this.endDatapoint('onLoad');
    };

    private endDatapoint(actionSource: string, error?: Error) {
        const datapoint = getSxSViewStore().datapoint;
        datapoint.addCustomProperty('EndDatapointFrom', actionSource);
        if (error) {
            datapoint.endWithError(DatapointStatus.ClientError, error);
        }

        datapoint.end();
    }
}
